"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DateTimeProviderMock_1 = __importDefault(require("../../../Mock/DateTimeProviderMock"));
const words = [
    "flair",
    "slime",
    "divided",
    "crude",
    "recorder",
    "regime",
    "magic",
    "middle-class",
    "significance",
    "triangular",
    "botched",
    "high-stakes",
    "full-length",
    "inscribe",
    "quash",
    "premonition",
    "murdered",
    "funny",
    "hurdle",
    "nanotechnology",
    "chaplain",
    "absolute",
    "inaugural",
    "kissing",
    "sadistic",
    "envy",
    "width",
    "skewed",
    "abet",
    "pet",
];
const randomWord = () => {
    return words[parseInt(Math.random() * words.length - 1 + "")];
};
const randomWords = (amount) => {
    const words = [];
    for (let i = 0; i < amount; i++) {
        words.push(randomWord());
    }
    return words;
};
const ratings = [];
let dt = DateTimeProviderMock_1.default.DEFAULT_DATE_TIME_RAW;
for (let i = 0; i < 100; i++) {
    let comment;
    if (i % 2 === 0) {
        comment = randomWords(Math.random() * 30 + 5).join(" ");
    }
    if (i === 50) {
        dt = DateTimeProviderMock_1.default.DEFAULT_DATE_TIME_RAW_LATER;
    }
    ratings.push({
        id: i.toString(),
        dateTime: dt,
        // @ts-ignore
        rating: parseInt(Math.random() * 5),
        comment,
    });
}
exports.default = ratings;
//# sourceMappingURL=ratings.js.map